export const packetToOption = (packet,store) => ({
  label: store.contracts[packet?.project]?.tag+' - '+packet?.name,
  value: packet?.id,
})
